import { MOBILE_DUMMY_IMAGES } from "../mobileDummyImages";

const productDetails = {
  title: "8X10. 5inch 26P 에스프리",
  heroImage: MOBILE_DUMMY_IMAGES.familyGarden,
  page: { current: "3", total: "20" },
  specs: [
    { label: "수량", value: "1개" },
    { label: "옵션", value: "Dove white" },
    { label: "사이즈", value: "8x8 하드커버 무광 / 무광지" },
  ],
};

const shippingInfo = {
  recipient: "서유진",
  receiver: "서유진",
  addressLine1: "서울특별시 마포구 소나무로 27, 3층 302호",
  addressLine2: "서울특별시 마포구 소나무로 27, 3층 302호",
  address: "서울특별시 마포구 소나무로 27, 3층 302호",
  detailAddress: "서울특별시 마포구 소나무로 27, 3층 302호",
  phone: "010-1234-5678",
  editPhone: "010-1234-5687",
  baseAddress: "서울특별시 마포구 소나무로 27",
  detail: "3층 302호",
};

const samplePhoto = MOBILE_DUMMY_IMAGES.babyCrown;

const photoSections = [
  {
    id: "cover",
    title: "첫페이지 (표지)",
    count: "1/1",
    type: "single",
    nodeId: "6368:6184",
    imageCount: 1,
    optional: true,
  },
  {
    id: "inner",
    title: "속지",
    count: "1/12",
    type: "grid",
    nodeId: "6368:6196",
    imageCount: 6,
    extraCount: 5,
    optional: true,
  },
  {
    id: "last",
    title: "마지막 페이지",
    count: "1/1",
    type: "single",
    nodeId: "6368:9322",
    imageCount: 1,
    optional: true,
  },
];

export { photoSections, productDetails, samplePhoto, shippingInfo };
